import { ArrowRight, Headphones } from 'lucide-react';

import Container from './Container';
import Reveal from '../../../components/Reveal';
import podcastPhone from './../../../assets/images/podcast-phone.png';

const Podcast = () => {
  return (
    <section className="relative overflow-hidden py-20 lg:py-24">
      {/* green band */}
      <div className="pointer-events-none absolute inset-x-0 top-1/2 z-0 h-[86%] -translate-y-1/2 overflow-hidden bg-gradient-to-b from-accent/10 via-accent/18 to-accent/10 xl:h-[56%]">
        <div className="glow left-[8%] top-1/2 h-[440px] w-[680px] -translate-y-1/2 bg-accent/16" />
      </div>

      <Container className="relative z-10 grid items-center gap-10 lg:grid-cols-2 xl:grid-cols-[1fr_1.15fr] xl:gap-6">
        {/* text */}
        <div>
          <Reveal>
            <span className="eyebrow">
              <Headphones size={14} />
              Podcast
            </span>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="head-fade font-heading mt-6 text-[2.1rem] font-bold leading-[1.1] sm:text-[2.8rem] lg:text-[3.1rem]">
              Listen to your study
              <br />
              materials anywhere.
            </h2>
          </Reveal>
          <Reveal delay={160}>
            <p className="mt-5 max-w-md text-[0.98rem] leading-relaxed text-white/60">
              Upload a book chapter, lecture notes, or study material, and School
              Hack turns it into a clear spoken podcast.
            </p>
          </Reveal>
          <Reveal delay={240}>
            <a
              href="https://app.schoolhack.ai"
              target="_blank"
              rel="noreferrer"
              className="btn-primary mt-8 px-6 py-3.5 text-[0.95rem]"
            >
              Create a Podcast
              <ArrowRight size={17} />
            </a>
          </Reveal>
        </div>

        {/* phone image */}
        <Reveal
          delay={160}
          className="relative mx-auto w-full max-w-[620px] xl:-ml-[8%] xl:mr-0 xl:w-[135%] xl:max-w-none"
        >
          <div className="glow left-1/2 top-1/2 h-[420px] w-[440px] -translate-x-1/2 -translate-y-1/2 bg-accent/18" />
          <img
            src={podcastPhone}
            alt="School Hack podcast player on phone"
            className="relative w-full animate-float object-contain drop-shadow-[0_50px_100px_rgba(0,0,0,0.55)]"
          />
        </Reveal>
      </Container>
    </section>
  );
};

export default Podcast;
